
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useSearchParams } from 'react-router-dom'
import STPMachineryOperationDataPopup from './STPPreventiveMachineryOperationDataPopup'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { Loading } from '../../../../../../Helper/Loading'
import { STPMachineryOperationDeleteAPI, STPMachineryOperationTableDataAPI, STPMachineryOperationTableExportDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveMachineryOperationSlice'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { STPUnitTypeDDL } from '../../../../../../Components/CommonDDL/STPUnitTypeDDL'
import { EquipmentTypeDataDDL } from '../../../../../../Components/CommonDDL/STPEquipmentTypeDDL'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { STPPreventiveMachineryOperationExportData } from './STPPreventiveMachineryOperationExportData'
import { TableNote } from '../../../../../../Components/Note/Note'


export default function STPPreventiveMachineryOperationData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPMachineryOperationPopupShow, setSTPMachineryOperationPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let ScreenName = searchParams.get("name")


    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [UnitType, setUnitType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EquipmentType, setEquipmentType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleEditOnClick = (item) => {
        setSTPMachineryOperationPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setSTPMachineryOperationPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setUnitType({
            ...UnitType,
            ID: 0,
            Label: 'Select...',
        })
        setEquipmentType({
            ...EquipmentType,
            ID: 0,
            Label: 'Select...',
        })

        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
        setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            ReadingDate: Date,
            M_WardID: WardName.ID,
            M_STP_UnitTypeID: UnitType.ID,
            M_STP_EquipmentTypeID: EquipmentType.ID,
            M_UserID: UserID,
            Flag:"Grid",
            token: token,
            From: From,
            To: To,
            handleGetExport:handleGetExport
        }
        dispatch(STPMachineryOperationTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.STPMachineryOperationTableData)

    const handleGetExport=()=>{
        const data = {
            ReadingDate: Date,
            M_WardID: WardName.ID,
            M_STP_UnitTypeID: UnitType.ID,
            M_STP_EquipmentTypeID: EquipmentType.ID,
            M_UserID: UserID,
            Flag:"Report",
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(STPMachineryOperationTableExportDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPMachineryOperationTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_STP_MachineryOperationID: item.t_stP_MachineryOperationID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(STPMachineryOperationDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.STPMachineryOperationDelete)


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Machinery Operation</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <STPPreventiveMachineryOperationExportData
                                                ExcelData={ExportTableData}
                                                name='Machinery Operation'
                                                Date={Date}
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-2 col-md-3">
                                                <label for=""><b>Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="ToDate"
                                                    value={Date}
                                                    onChange={(e) => setDate(e.target.value)}
                                                />

                                            </div>

                                            <div className="col-lg-2 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-4">
                                                <STPUnitTypeDDL
                                                    UnitType={UnitType}
                                                    setUnitType={setUnitType}

                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-4">
                                                <EquipmentTypeDataDDL
                                                    EquipmentType={EquipmentType}
                                                    setEquipmentType={setEquipmentType}
                                                    UnitType={UnitType}
                                                    ScreenName={ScreenName}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-12 col-lg-2 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1 mb-5">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Reading Date</th>
                                                        <th>Unit Type</th>
                                                        <th>Equipment Type </th>
                                                        <th>Equipment Details </th>
                                                        <th>Operation Hours </th>
                                                        <th>Current Amp</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{item.unitType ? item.unitType : '-'}</td>
                                                                <td>{item.equipmentType ? item.equipmentType : '-'}</td>
                                                                <td>{item.equipmentDetails ? item.equipmentDetails : '-'}</td>
                                                                <td style={{ textAlign: "right" }}>{item.operationHours!= 0.0 ? item.operationHours.toFixed(2) : '0.0'}</td>
                                                                <td style={{ textAlign: "right" }}>{item.currentAmp != 0.0 ? item.currentAmp.toFixed(2) : '0.0'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>
                                                                                <span>
                                                                                    <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => handleEditOnClick(item)}
                                                                                    >
                                                                                    </i>
                                                                                </span>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        item={item}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={10}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    STPMachineryOperationPopupShow ?
                        <STPMachineryOperationDataPopup
                            open={STPMachineryOperationPopupShow}
                            popupHeading="Work Name"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}